module.exports = __webpack_public_path__ + "img/04.363cda8c.jpg";